import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, {useState} from "react";


const headers = [
  {
    key: "customer_name",
    name: "Customer Name",
  },
  {
    key: "member_code",
    name: "Member Card Number",
  },
  {
    key: "shop_name",
    name: "Shop Name",
  },
  {
    key: "loyalty_points",
    name: "Point",
  },

  {
    key: "advanced_mmk",
    name: "Advanced MMK",
  },

  {
    key: "advanced_thb",
    name: "Advanced THB",
  },
  {
    key: "phone1",
    name: "Phone",
  },
  {
    key: "address",
    name: "Address",
  },
  {
    key: "status",
    name: "Status",
  },
];

const detailPopupHeaders = [
  {
    key: "wholesale_customer_code",
    name: "Wholesale Customer ID",
  },
  {
    key: "customer_name",
    name: "Customer Name",
  },
  {
    key: "member_code",
    name: "Member Card Number",
  },
  {
    key: "shop_name",
    name: "Shop Name",
  },
  {
    key: "phone1",
    name: "Phone 1",
  },
  {
    key: "phone2",
    name: "Phone 2",
  },
  {
    key: "phone3",
    name: "Phone 3",
  },
  {
    key: "phone4",
    name: "Phone 4",
  },
  {
    key: "address",
    name: "Address",
  },
];

export default function WholesaleCustomerList() {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  // const handleSearch = (value) => {
  //   setQuery({
  //     customer_name: value.trim(),
  //   });
  // };

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        search: trimmed,
      });
    }else{
        setQuery({
      
    });
    }
  };


  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/wholesaleCustomer",
    defaultQuery: "status=ACTIVE",
  });

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Wholesale Customer List"
      data={data}
      headers={headers}
      detailPopupTitle="Wholesale Customer Information"
      detailPopupHeaders={detailPopupHeaders}
      idKey="customer_id"
      endPoint="/wholesaleCustomer"
      hasPointChange
      pointChangeModel="WholesaleCustomer"
      hasSearch
      hasCreate
      module="Customer"
      subModule="Retail Customer"
      createPath={`/customer/wholesale/create`}
      hasActions
      setCurrentPage={setCurrentPage}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
      setQuery={setQuery}
    />
  );
}
